import { createWebHistory, createRouter } from 'vue-router'

import Home from './views/home/HomeComponent.vue'
import Logout from './views/logout/LogoutComponent.vue'

import DistributorList from './views/distributor/list/DistributorList.vue'
import DistributorEdit from './views/distributor/edit/DistributorEdit.vue'
import AffiliateList from './views/affiliate/list/AffiliateList.vue'
import AffiliateDetail from './views/affiliate/detail/AffiliateDetail.vue'
import AffiliateEdit from './views/affiliate/edit/AffiliateEdit.vue'
import AccountList from './views/account/list/AccountList.vue'
import AccountDetail from './views/account/detail/AccountDetail.vue'
import OperationDetail from './views/operation/detail/OperationDetail.vue'
import AuthorizationList from './views/authorization/list/AuthorizationList.vue'
import AuthorizationDetail from './views/authorization/detail/AuthorizationDetail.vue'
import BeneficiaryList from './views/beneficiary/list/BeneficiaryList.vue'
import BeneficiaryDetail from './views/beneficiary/detail/BeneficiaryDetail.vue'
import CardList from './views/card/list/CardList.vue'
import CardDetail from './views/card/detail/CardDetail.vue'
import ProductList from './views/product/list/ProductList.vue'
import ProductDetail from './views/product/detail/ProductDetail.vue'
import ProductEdit from './views/product/edit/ProductEdit.vue'
import ProductCopy from './views/product/copy/ProductCopy.vue'
import ProductCreate from './views/product/create/ProductCreate.vue'
import RequestList from './views/request/list/RequestList.vue'
import RequestDetail from './views/request/detail/RequestDetail.vue'
import ProductImport from './views/product/import/ProductImport.vue'
import ProductExport from './views/product/export/ProductExport.vue'
import ClearingList from './views/clearing/list/ClearingList.vue'
import ClearingDetail from './views/clearing/detail/ClearingDetail.vue'
import ControlParam from './views/param/ControlParam.vue'
import OrderList from './views/order/list/OrderList.vue'
import OrderDetail from './views/order/detail/OrderDetail.vue'
import ProfileList from './views/administration/profile/list/ProfileList.vue'
import ProfileCreate from './views/administration/profile/create/ProfileCreate.vue'
import ProfileEdit from './views/administration/profile/edit/ProfileEdit.vue'
import UserCreate from './views/administration/user/create/UserCreate.vue'
import UserEdit from './views/administration/user/edit/UserEdit.vue'
import UserList from './views/administration/user/list/UserList.vue'
import PasswordChange from './views/administration/user/password/PasswordChange.vue'

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes: [
    {
      // Old route saved in browsers, redirect to home
      path: '/login',
      redirect: 'home'
    },
    {
      path: '/',
      redirect: 'home'
    },
    {
      path: '/logout',
      name: 'logout',
      meta: {
        auth: false
      },
      component: Logout
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        auth: true
      },
      component: Home
    },
    {
      path: '/vue/distributors',
      name: 'distributor-list',
      meta: {
        auth: true
      },
      component: DistributorList
    },
    {
      path: '/vue/distributors/edit',
      name: 'distributor-edit',
      meta: {
        auth: true
      },
      component: DistributorEdit
    },
    {
      path: '/vue/affiliates',
      name: 'affiliate-list',
      meta: {
        auth: true
      },
      component: AffiliateList
    },
    {
      path: '/vue/affiliates/detail/',
      name: 'affiliate-detail',
      meta: {
        auth: true
      },
      component: AffiliateDetail
    },
    {
      path: '/vue/affiliates/edit/',
      name: 'affiliate-edit',
      meta: {
        auth: true
      },
      component: AffiliateEdit
    },
    {
      path: '/vue/beneficiaryservices',
      name: 'beneficiaryservice-list',
      meta: {
        auth: true
      },
      component: BeneficiaryList
    },
    {
      path: '/vue/beneficiaryservices/detail/',
      name: 'beneficiaryservice-detail',
      meta: {
        auth: true
      },
      component: BeneficiaryDetail
    },
    {
      path: '/vue/cards',
      name: 'card-list',
      meta: {
        auth: true
      },
      component: CardList
    },
    {
      path: '/vue/cards/detail',
      name: 'card-detail',
      meta: {
        auth: true
      },
      component: CardDetail
    },
    {
      path: '/vue/accounts',
      name: 'account-list',
      meta: {
        auth: true
      },
      component: AccountList
    },
    {
      path: '/vue/accounts/detail',
      name: 'account-detail',
      meta: {
        auth: true
      },
      component: AccountDetail
    },
    {
      path: '/vue/operations/detail',
      name: 'operation-detail',
      meta: {
        auth: true
      },
      component: OperationDetail
    },
    {
      path: '/vue/orders',
      name: 'order-list',
      meta: {
        auth: true
      },
      component: OrderList
    },
    {
      path: '/vue/orders/detail',
      name: 'order-detail',
      meta: {
        auth: true
      },
      component: OrderDetail
    },
    {
      path: '/vue/authorizations',
      name: 'authorization-list',
      meta: {
        auth: true
      },
      component: AuthorizationList
    },
    {
      path: '/vue/authorizations/detail',
      name: 'authorization-detail',
      meta: {
        auth: true
      },
      component: AuthorizationDetail
    },
    {
      path: '/vue/param/control',
      name: 'param-control',
      meta: {
        auth: true
      },
      component: ControlParam
    },
    {
      path: '/vue/clearings',
      name: 'clearing-list',
      meta: {
        auth: true
      },
      component: ClearingList
    },
    {
      path: '/vue/clearings/detail',
      name: 'clearing-detail',
      meta: {
        auth: true
      },
      component: ClearingDetail
    },
    {
      path: '/vue/profiles',
      name: 'profile-list',
      meta: {
        auth: true
      },
      component: ProfileList
    },
    {
      path: '/vue/profiles/create',
      name: 'profile-create',
      meta: {
        auth: true
      },
      component: ProfileCreate
    },
    {
      path: '/vue/profiles/edit',
      name: 'profile-edit',
      meta: {
        auth: true
      },
      component: ProfileEdit
    },
    {
      path: '/vue/users',
      name: 'user-list',
      meta: {
        auth: true
      },
      component: UserList
    },
    {
      path: '/vue/users/password/change',
      name: 'password-change',
      meta: {
        auth: true
      },
      component: PasswordChange
    },
    {
      path: '/vue/users/create',
      name: 'user-create',
      meta: {
        auth: true
      },
      component: UserCreate
    },
    {
      path: '/vue/users/edit',
      name: 'user-edit',
      meta: {
        auth: true
      },
      component: UserEdit
    },
    {
      path: '/vue/products',
      name: 'product-list',
      meta: {
        auth: true
      },
      component: ProductList
    },
    {
      path: '/vue/products/detail',
      name: 'product-detail',
      meta: {
        auth: true
      },
      component: ProductDetail
    },
    {
      path: '/vue/products/edit',
      name: 'product-edit',
      meta: {
        auth: true
      },
      component: ProductEdit
    },
    {
      path: '/vue/products/copy',
      name: 'product-copy',
      meta: {
        auth: true
      },
      component: ProductCopy
    },
    {
      path: '/vue/products/create',
      name: 'product-create',
      meta: {
        auth: true
      },
      component: ProductCreate
    },
    {
      path: '/vue/requests/list',
      name: 'request-list',
      meta: {
        auth: true
      },
      component: RequestList
    },
    {
      path: '/vue/requests/detail',
      name: 'request-details',
      meta: {
        auth: true
      },
      component: RequestDetail
    },
    {
      path: '/vue/products/import',
      name: 'product-import',
      meta: {
        auth: true
      },
      component: ProductImport
    },
    {
      path: '/vue/products/export',
      name: 'product-export',
      meta: {
        auth: false
      },
      component: ProductExport
    },
    {
      path: '/*',
      redirect: '/'
    }
  ]
})


export default router
